const BaseUrl = {
  // API_URL: "https://britetrace.itechnolabs.tech",
  API_URL:"https://api.britetrace.cc/"
};

export default BaseUrl;
